import React, { useState } from "react";
import InputGroup from './Utility/InputGroup';
import Notice from "./Utility/Notice";
import GoogleIcon from "./Utility/GoogleIcon";
import { login, authWithGoogle } from "../Backend/Authentication/AuthService";
import { Link, useNavigate } from 'react-router-dom';

export default function Login({ setGlobalNotice }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [notice, setNotice] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleEmailLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setNotice(null);
        const result = await login(email, password);
        if (result.success) {
            const userName = result.user.displayName || "User"; // Fallback to "User"

            setGlobalNotice({
                type: "success",
                text: `Welcome Back, ${userName}!`
            });
            navigate('/', { replace: true });
        } else {
            console.error("Email login error:", error);
            setNotice({ type: "error", text: result.error });
            setError(result.error);
        }
    };
    const handleGoogleAuth = async () => {
        setLoading(true);
        setNotice(null);
        setError(null);

        const result = await authWithGoogle();
        if (!result.success) {
            setLoading(false);
            setNotice({ type: "error", text: result.error });
            setError(result.error);
        }
    };


    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-6">
            <header className="text-center mb-5">
                <h1 className="text-4xl font-bold tracking-wide">okul.live</h1>
            </header>

            <main className="w-full max-w-sm bg-white rounded-lg shadow-xl p-6">
                <h2 className="text-2xl font-semibold text-center mb-6">Log In</h2>

                <button
                    onClick={handleGoogleAuth}
                    className="btn-secondary w-full flex items-center justify-center gap-2"
                    disabled={loading}
                >
                    <GoogleIcon />
                    Continue with Google
                </button>

                <div className="relative my-6">
                    <div className="absolute inset-0 flex items-center">
                        <div className="w-full border-t border-gray-300"></div>
                    </div>
                    <div className="relative flex justify-center text-sm">
                        <span className="bg-white px-2 text-gray-500">or</span>
                    </div>
                </div>

                <form onSubmit={handleEmailLogin} className="flex flex-col gap-4">
                    <InputGroup label="Email" id="email">
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="you@example.com"
                        />
                    </InputGroup>
                    <InputGroup label="Password" id="password">
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="••••••••"
                        />
                    </InputGroup>

                    <button type="submit" className="btn-primary" disabled={loading}>
                        {loading ? "Logging in..." : "Log In"}
                    </button>
                </form>


                {notice && (
                    <Notice type={notice.type} className="mt-4">{notice.text}</Notice>
                )}

                <p className="text-center text-sm text-gray-600 mt-6">
                    Don't have an account?{" "}
                    <button onClick={
                        () => navigate('/signup')
                    } className="font-medium text-blue-600 hover:underline">
                        Sign Up
                    </button>
                </p>
                <p className="text-center text-sm text-gray-600 mt-2">
                    Forgot your password?{" "}
                    <button onClick={
                        () => { }
                    } className="font-medium text-blue-600 hover:underline">
                        Change Password.
                    </button>
                </p>
            </main>
            <style>{`
                .btn-primary { margin-top: 6px; padding: 10px 14px; height: 44px; font-size: 16px; border-radius: 8px; border: none; cursor: pointer; background-color: #2563eb; color: #fff; transition: background-color 0.2s; }
                .btn-primary:hover { background-color: #1d4ed8; }
                .btn-primary:disabled { background-color: #93c5fd; cursor: not-allowed; }
                .btn-secondary { margin-top: 0; padding: 10px 14px; height: 44px; font-size: 16px; border-radius: 8px; border: 1px solid #d1d5db; cursor: pointer; background-color: #ffffff; color: #1f2937; transition: background-color 0.2s; }
                .btn-secondary:hover { background-color: #f9fafb; }
                input[type="text"], input[type="email"], input[type="password"] { height: 40px; padding: 8px 10px; font-size: 15px; border-radius: 6px; border: 1px solid #ddd; width: 100%; }
            `}</style>
        </div>
    );
}



/**
 * SVG icon for Google button.
 */

